<template>
  <div class="locations card">
    <page-header title="Location" breadcrumb="Dashboard >> Locations" />
    <locations-table />
  </div>
</template>

<script>
import LocationsTable from "./LocationsTable";
import PageHeader from "@/components/UI/NewPageHeader";

export default {
  components: {
    LocationsTable,
    PageHeader
  },
  data() {
    return {};
  },
};
</script>

<style scoped></style>
